import { Post } from "../../../api/client";
import { ToastErrorStyles } from "../../../constants/toastStyles";
import { AppDispatch } from "../../storeConfig/store";
import { closeLoader, openLoader } from "../loader/loaderActions";
import { updateFinalOrderResponse } from "../orderDetails/orderDetailsActions";
import { openToastAndSetContent } from "../toast/toastActions";

const clearcacheddata = (interval: number, clearkeys: boolean) => {
  if (!interval) return;
  clearInterval(interval);
  sessionStorage.setItem("checkout-interval-tracker", "");
  sessionStorage.setItem("checkout-tracked-reference", "");
  if (clearkeys) {
    sessionStorage.setItem("checkout_current_api_key", "");
    sessionStorage.setItem("checkout_current_encryption_key", "");
  }
};

export const orderStatusAction = async (
  payload: any,
  dispatch: Function,
  cb: Function | undefined,
  __window: Window | null = null
) => {
  try {
    var checkoutstatus = sessionStorage.getItem("checkout-payment-completed");
    var checkoutinterval = sessionStorage.getItem("checkout-interval-tracker");

    const interval = Number(checkoutinterval);
    const starttime = new Date(
      sessionStorage.getItem("checkout-track-start") || new Date()
    );
    const diff = (new Date().getTime() - starttime.getTime()) / (1000 * 60);
    if (diff > 10) {
      clearcacheddata(interval, false);
      cb && typeof cb === "function" && cb({ status: "time-out" });
      dispatch(closeLoader());
      return;
    }
    if (checkoutstatus === "true" && !!checkoutinterval) {
      if (interval) {
        clearcacheddata(interval, true);
      }
      return;
    }

    const res: any = await Post("payment/order/status", payload);
    var data = res?.data;
    if (data?.data?.isFinalStatus) {
      sessionStorage.setItem("checkout-payment-completed", "true");

      const redirectUrl = sessionStorage.getItem("redirectUrl");

      dispatch(
        updateFinalOrderResponse({
          ...data,
          redirectUrl: redirectUrl
            ? `${redirectUrl}?order_payment_reference=${data?.data?.orderSummary?.orderReference}&status=${data?.status}`
            : null,
        })
      );
      if (redirectUrl) {
        sessionStorage.removeItem("redirectUrl");
        return;
      }
      __window?.close();
      window?.top?.postMessage(data, "*");
      const typeofCallBack = typeof cb;
      if (cb && typeofCallBack === "function") {
        cb({ status: "completed" });
      }
      dispatch(closeLoader());
    }
  } catch (error: any) {
    dispatch(closeLoader());
  }
};

export const TrackOrderStatusAction = async (
  payload: any,
  context: any,
  dispatch: Function,
  cb: Function | undefined,
  __window: Window | null = null
) => {
  try {
    // Define dynamic messages and loader types based on context
    const loaderMessages: Record<string, string> = {
      bank: "Loading Bank Service",
      transfer: "Checking Transaction Status",
      directDebit: "Checking Direct Debit Status",
      opay: "Verifying Transaction",
      crypto: "Verifying Transaction",
      palmpay: "Checking transaction status",
      default: " ",
    };

    // Select message and type based on context
    const message = loaderMessages[context] || loaderMessages.default;

    // Dispatch dynamic loader
    dispatch(openLoader(message, context));

    const existingInterval = Number(
      sessionStorage.getItem("checkout-interval-tracker"),
    );
    const trackedReference = sessionStorage.getItem(
      "checkout-tracked-reference",
    );

    if (existingInterval && trackedReference === payload?.reference) {
      // Already polling this exact order (e.g. auto-start on mount plus the
      // "I have made the payment" click) — don't spin up a second interval.
      return;
    }

    if (existingInterval) {
      // Polling was left over from a previous order in this tab (e.g. a new
      // payment link pasted after a prior payment completed) — stop it
      // before starting the poll for the new one.
      clearInterval(existingInterval);
    }

    // A prior order in this tab may have marked itself complete; that flag
    // must not block polling for this (new) order.
    sessionStorage.setItem("checkout-payment-completed", "");
    sessionStorage.setItem("checkout-tracked-reference", payload?.reference ?? "");

    const interval = setInterval(() => {
      const checkoutinterval = sessionStorage.getItem(
        "checkout-interval-tracker"
      );

      orderStatusAction(payload, dispatch, cb, __window);
      if (!checkoutinterval) {
        clearInterval(interval);
      }
    }, 1000);
    sessionStorage.setItem("checkout-track-start", new Date().toString());
    sessionStorage.setItem("checkout-interval-tracker", interval.toString());
  } catch (error: any) {
    dispatch(closeLoader());
    const message =
      error?.response?.data?.Message || error?.response?.data?.message;
    dispatch(
      openToastAndSetContent({
        toastStyles: ToastErrorStyles,
        toastContent: message,
      })
    );
  }
};

export const payOrderAction = async (
  payload: any,
  context: any,
  dispatch: Function,
  cb: Function
) => {
  try {
    // Define dynamic messages and loader types based on context
    const loaderMessages: Record<string, string> = {
      bank: "",
      transfer: "",
      default: "",
    };

    // Select message and type based on context
    const message = loaderMessages[context] || loaderMessages.default;

    // Dispatch dynamic loader
    dispatch(openLoader(message, context));
    // console.log({ payload });

    const data: any = await Post("payment/order/pay", payload);
    const res = data?.data;
    if (typeof cb === "function") {
      cb(res);
    }
    dispatch(closeLoader());
  } catch (error: any) {
    dispatch(closeLoader());
    const message =
      error?.response?.data?.Message || error?.response?.data?.message;
    dispatch(
      openToastAndSetContent({
        toastStyles: ToastErrorStyles,
        toastContent: message,
      })
    );
  }
};

export const authorizePayOrderAction = async (
  payload: any,
  context: any,
  dispatch: Function,
  cb: Function
) => {
  try {
    // Define dynamic messages and loader types based on context
    const loaderMessages: Record<string, string> = {
      bank: "Loading Bank Service",
      transfer: "Checking Transaction Status",
      default: "",
    };

    // Select message and type based on context
    const message = loaderMessages[context] || loaderMessages.default;

    // Dispatch dynamic loader
    dispatch(openLoader(message, context));
    const data: any = await Post("payment/order/pay/authorize", payload);
    const res = data?.data;
    cb(res);
    dispatch(closeLoader());
  } catch (error: any) {
    dispatch(closeLoader());
    const message =
      error?.response?.data?.Message || error?.response?.data?.message;
    dispatch(
      openToastAndSetContent({
        toastStyles: ToastErrorStyles,
        toastContent: message,
      })
    );
  }
};

export const trackOrderAction = (payload: any, cb: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const data: any = await Post("payment/order/event/track", payload);
      const res = data?.data;
      cb(res);

      // Optional: Dispatch success action
      dispatch({ type: "TRACK_ORDER_SUCCESS", payload: res });
    } catch (error: any) {
      console.error(error);

      // Optional: Dispatch failure action
      dispatch({ type: "TRACK_ORDER_FAILURE", error });
    }
  };
};

export function openWin(redirectUrl: string) {
  const myWindow = window.open(redirectUrl, "_blank");
  return myWindow;
}

export function closeWin(__window: Window | null) {
  __window?.close();
}
